import {useListView} from '../core/ListViewProvider'
import {ReservationsListToolbar} from './ReservationListToolbar'
import {ReservationsListGrouping} from './ReservationListGrouping'
import {ReservationsListSearchComponent} from './ReservationListSearchComponent'

const ReservationsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ReservationsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <ReservationsListGrouping /> : <ReservationsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ReservationsListHeader}
